import request from '@/utils/request';
import type { User } from './data';

export function checkLogin() {
  // return request.get<User>('/operatorplatform/account/isLogin');
  return request.get<User>('/energy/op/cookie/isLogin');
}

